import { useEffect, useState } from 'react';
import { get } from './api';

/** The business this address belongs to (its own domain), or nothing on the shared Teknika CRM address. */
export interface Site {
  slug?: string;
  name?: string;
  logo?: string;
}

/** How long a sign-in page waits to learn whose domain it is before showing the usual form. */
const SITE_WAIT_MS = 5_000;

/**
 * Undefined until the server answers, so a sign-in page can wait rather than flash the
 * generic form. A failed request, or none within SITE_WAIT_MS, counts as the shared
 * address: the usual form still works. The first answer stands, so a late reply never
 * swaps the form under someone already typing.
 */
export function useSite(): Site | undefined {
  const [site, setSite] = useState<Site>();
  useEffect(() => {
    let live = true;
    const settle = (s: Site) => {
      if (live) setSite((current) => current ?? s);
    };
    const timer = setTimeout(() => settle({}), SITE_WAIT_MS);
    get<Site>('/api/site')
      .then(settle, () => settle({}))
      .finally(() => clearTimeout(timer));
    return () => {
      live = false;
      clearTimeout(timer);
    };
  }, []);
  return site;
}
